import { MATERIALS } from '@invaders/sim';

/** Material id -> ABGR pixel (little-endian RGBA in memory), generated from the material registry. */
export function buildPalette(): Uint32Array {
  const palette = new Uint32Array(256);
  MATERIALS.forEach((m, id) => { palette[id] = rgbToAbgr(m.color); });
  return palette;
}

export function rgbToAbgr(rgb: number): number {
  return ((0xff << 24) | ((rgb & 0xff) << 16) | (rgb & 0xff00) | ((rgb >> 16) & 0xff)) >>> 0;
}

export function cssColor(rgb: number): string {
  return `#${rgb.toString(16).padStart(6, '0')}`;
}

/** Shades per material in buildShadedPalette(). */
export const SHADES = 4;

/**
 * GDD "teinte": a slight variation of colour per cell, so that a material does not look flat. It is display
 * only (derived from the cell position, see ViewRenderer), never part of the game state. Entry (id << 2) | shade.
 */
export function buildShadedPalette(): Uint32Array {
  const out = new Uint32Array(256 * SHADES);
  const factors = [0.94, 0.98, 1.02, 1.06];
  MATERIALS.forEach((m, id) => {
    for (let k = 0; k < SHADES; k++) {
      const f = id === 0 ? 1 : factors[k];
      const ch = (v: number) => Math.min(255, Math.round(v * f));
      const rgb = (ch((m.color >> 16) & 0xff) << 16) | (ch((m.color >> 8) & 0xff) << 8) | ch(m.color & 0xff);
      out[(id << 2) | k] = rgbToAbgr(rgb);
    }
  });
  return out;
}

